import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotifierService } from 'angular-notifier';
import { catchError } from 'rxjs/operators';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { MomService } from 'src/app/service/mom.service';
import { TemplateDialogComponent } from '../template-dialog/template-dialog.component';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-grapes-js-popup',
  templateUrl: './grapes-js-popup.component.html',
  styleUrls: ['./grapes-js-popup.component.css']
})
export class GrapesJsPopupComponent implements OnInit {

  minTemplateName:any;
  templates: any;
  option:any;
  templateData:any;
  templateResponse:any;
  type ="Public"
  templateForm = new UntypedFormGroup({
    minTemplateName: new UntypedFormControl('',Validators.required),
    categoryStates: new UntypedFormControl('',Validators.required),
    templateState : new UntypedFormControl('',Validators.required),
    templateDesc: new UntypedFormControl(''),
    categoryName: new UntypedFormControl('',Validators.required),
    type:new UntypedFormControl('' ,Validators.required),
})
isSubmitted  =  false;
selected:any;
categoryType: any = <any>[];
templateList:any = [];
categoryShow = false;
categoryName=true;
isLoading: boolean = false;
categoryError=false;
  momRes:any;
  categoryId:any;
  minTemplateId:any;
  curMom:any;
  meetingResponse:any;
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  exitTemplateCode: any;
  constructor(private notifier: NotifierService, private meetingService: MeetingService, @Inject(MAT_DIALOG_DATA) data: any, private dialogRef: MatDialogRef<GrapesJsPopupComponent>,private globals:Globals,private momService: MomService,private spinner: NgxSpinnerService,public  notifiy : NotifierService,private dialog: MatDialog,private readonly breakpointObserver: BreakpointObserver) {
    this.isLoading = true;
    this.option = data.option;
    this.templateData = data.templateData;
    this.templateResponse = data.templateResponse
    if (this.option == 'update') {
      this.templateForm.controls['minTemplateName'].setValue(this.templateResponse.minTemplateName);
      this.templateForm.controls['templateDesc'].setValue(this.templateResponse.description);
      this.templateForm.controls['categoryStates'].setValue(this.templateResponse.fkCategory);
      this.type = this.templateResponse.type;
      this.selected = Number(this.templateResponse.fkCategory)
    }

    if(this.option=='categoryUpdate'){
      this.momRes = data.momRes
      this.curMom = data.curMom;
      this.meetingResponse = data.meetingResp;
       if(this.curMom.categoryId != null){
          this.categoryId = this.momRes.categoryId
          const req = {
            fkCategory: this.categoryId,
            "orgCode": localStorage.getItem("orgCode"),
            "createdBy": localStorage.getItem("createdBy")
        };
      
        this.meetingService.fetchMinutesTemplate(req).subscribe((response: any) => {
            this.templateList = response.body;
            if(this.curMom.minTemplateId != null){
              this.minTemplateId = this.momRes.minTemplateId
            }
        });
       }
       else if(this.meetingResponse.categoryId!=null){
        this.categoryId = this.meetingResponse.categoryId
          const req = {
            fkCategory: this.categoryId,
            "orgCode": localStorage.getItem("orgCode"),
            "createdBy": localStorage.getItem("createdBy")
        };
      
        this.meetingService.fetchMinutesTemplate(req).subscribe((response: any) => {
            this.templateList = response.body;
            if(this.meetingResponse.minTemplateId != null){
              this.minTemplateId = this.meetingResponse.minTemplateId
            }
        });
       }
       else{
        var codeDto = { parentCode: 'TCATEGORY', code: 'general' }
        // this.categoryId = 846
        this.meetingService.getTZNameByCode(codeDto).subscribe(responsedata => {
          // this.selectedCategory.setValue(responsedata.body.codeId); 
          this.categoryId = responsedata.body.codeId
          const req = {
            fkCategory: this.categoryId,
            "orgCode": localStorage.getItem("orgCode"),
            "createdBy": localStorage.getItem("createdBy")
        };
  
          this.meetingService.fetchMinutesTemplate(req).subscribe((response: any) => {
            this.templateList = response.body;
            this.minTemplateId = 1;
        });
        })
       }
     }

    var categoryReq = { "orgCode": localStorage.getItem("orgCode"), "userId": localStorage.getItem("userId") };
    this.meetingService.loadCategory(categoryReq).subscribe((response: any) => {
      this.categoryType = response.body;
      if (this.selected == undefined) {
        this.selected = this.categoryType[0]['codeId'];
      }
      else {
        this.selected = Number(this.templateResponse.fkCategory)
      }
      const req = {
        "fkCategory": this.selected,
        "orgCode": localStorage.getItem("orgCode"),
        "createdBy": localStorage.getItem("createdBy")
      };
      if(this.option=='edit'){
        this.fetchTemplate(req);
      }      this.isLoading = false;
    });
  }

  ngOnInit(): void {
  }

  get formControls() {
    return this.templateForm.controls;
  }

  saveTemplate(saveTemplate: any) {
    if (this.option == 'save') {
      var createdBy = localStorage.getItem("userId");
      var orgCode = localStorage.getItem("orgCode");
      this.templateData.minTemplateName = this.templateForm.value.minTemplateName;
      this.templateData.minTemplateCode = this.templateForm.value.minTemplateName.replace(/\s+/g, '');
      this.templateData.type = this.templateForm.value.type;
      this.templateData.createdBy = createdBy;
      this.templateData.orgCode = orgCode;

      if (this.templateForm.value.categoryStates != null && this.templateForm.value.categoryStates != "") {
        this.templateData.fkCategory = this.templateForm.value.categoryStates;
        this.templateData.description = this.templateForm.value.templateDesc;
      }
      else {
        this.templateData.categoryName = this.templateForm.value.categoryName
      }
    }
    else {
      var createdBy = localStorage.getItem("userId");
      var orgCode = localStorage.getItem("orgCode");
      this.templateResponse.html = this.templateData.html;
      this.templateResponse.css = this.templateData.css;
      this.templateResponse.formatedHTML = this.templateData.formatedHTML;
      // this.templateResponse.images = this.templateData.images;
      this.templateResponse.type = this.templateForm.value.type;
      this.templateResponse.minTemplateName = this.templateForm.value.minTemplateName;
      this.templateResponse.minTemplateCode = this.templateForm.value.minTemplateName.replace(/\s+/g, '');
      if (this.templateForm.value.categoryStates != null && this.templateForm.value.categoryStates != "") {
        this.templateResponse.fkCategory = this.templateForm.value.categoryStates;
      }
      else {
        this.templateResponse.categoryName = this.templateForm.value.categoryName
      }
      if (this.templateForm.value.templateDesc != null && this.templateForm.value.templateDesc != "") {
        this.templateResponse.description = this.templateForm.value.templateDesc;
      }
      this.templateData = this.templateResponse
    }
    const req = {
      "fkCategory": this.templateForm.value.categoryStates,
      "minTemplateCode": this.templateForm.value.minTemplateName.replace(/\s+/g, '')
    };

    this.meetingService.isMinTemplateExists(req).subscribe((response: any) => {
      if (response.body != null && this.option != 'update') {
        this.notifier.notify("error", "The template name already exists.");
      }
      else if (this.option == 'update' && response.body != null && this.exitTemplateCode != this.templateResponse.minTemplateCode) {
        this.notifier.notify("error", "The template name already exists.");
      } else {
        this.meetingService.saveMinutesTemplate(this.templateData, saveTemplate).subscribe((tempRes: any) => {
          if (this.option == 'save') {
            this.notifier.show({
              type: 'success',
              message: 'Template saved successfully.'
            });
            //  this.notifier.notify("success","Template saved successfully");
          }
          else {
            this.notifier.show({
              type: 'success',
              message: 'Template updated successfully.'
            });
            //  this.notifier.notify("success","Template updated successfully");
          }
          this.dialogRef.close(tempRes);
        })
      }
    });
  }

  isopenCategory(data: any) {
    
    this.categoryShow = !this.categoryShow;
    this.categoryName = false;
    this.categoryError = false;
    if (data == true) {

      this.templateForm.controls.categoryStates.disable();
      this.templateForm.controls.categoryName.enable();
    }
    else {
      this.templateForm.controls.categoryStates.enable();
    }
    //this.templateForm.controls['categoryStates'].disable();
    //document.getElementById('category-select')?.setAttribute('class','templaedisbale');
    ///  document.getElementById('category-selectone')?.setAttribute('class','templaedisbaleone');
    let categoryBtn = <HTMLElement>document.getElementById('category-btn');
    categoryBtn.style.display = 'none';
    let categorySelectoneField = <HTMLElement>document.getElementById('category-selectone-field');
    categorySelectoneField.style.display = 'none'
    // categoryBtn.setAttribute('style','background-color: rgb(233, 233, 233) !important;')
  }


  saveMinutesTemplate() {
    this.isSubmitted = true;
    // if(this.templateForm.invalid){
    
    //    return;
    //  }
    const minTemplateNameValue = this.templateForm.value.minTemplateName;
    if (!minTemplateNameValue || minTemplateNameValue.trim() === '') {
      // alert('Please enter the template name.'); // Notify user
      return; // Exit the function
    }


    if (this.categoryShow) {
      const categoryNameValue = this.templateForm.value.categoryName;
      if (!categoryNameValue || categoryNameValue.trim() === '') {
        // alert('Please enter the template name.'); // Notify user
        return; // Exit the function
      }
    }

    if (this.option == 'save')
      this.saveTemplate('true');
    else
      this.saveTemplate('false');


  }

  filterCondition(event: any) {
    this.dialogRef.close(event);
  }

  filterCategory(event: any) {
    if(this.option == 'edit' || this.option =='categoryUpdate'){
      this.categoryId = event.value;
      this.minTemplateId = null;
      if(this.option != 'edit'){
        this.saveOrUpdateMomDetail('N');
      }
      var req = {
        orgCode: localStorage.getItem('orgCode'),
        createdBy: localStorage.getItem('userId'),
        fkCategory: event.value
      }
      this.fetchTemplate(req);
    }
  }

  saveOrUpdateMomDetail(isNewTab:any) {
    var json:any={
      "fkMeetingEntityId":this.momRes.meetingId,
      "userId":this.globals.userId,
      "orgCode":this.globals.orgCode,
      "visitorTimeZone":this.globals.vTimeZone,
      "categoryId" : this.categoryId,
      "minTemplateId" : this.minTemplateId
    };
    if(isNewTab!=null && isNewTab!=undefined && isNewTab!="Y"){
      json["pkMomDetailId"] =this.momRes.pkMomDetailId;
      json["momTitle"]=this.momRes.momTitle;
      json["momStatusCode"]=this.momRes.momStatusCode
    }
    return new Promise(async (resolve, reject) => {
      await this.momService.saveOrUpdateMomDetail(json).subscribe(res => {
        if (res.body != null && res.body != undefined) {
          //this.momList.push(res.body);
          resolve(res.body);
        }
      });
    });
  }

  fetchTemplate(reqJSON:any): void {
    this.spinner.show();
    this.meetingService.fetchMinutesTemplate(reqJSON).subscribe((response: any) => {
       this.spinner.hide();
       var templateList=response.body;
       if(templateList.length==0){  
          this.notifiy.show({
            type: 'error',
            message:'No templates available.Please choose another'
          });
          this.templateList = [];
          return;
       }
      this.templateList = response.body
    });
}

onSubCategorySelect(event: any): void {
  this.spinner.show();
  this.minTemplateId = event.value;
  this.saveOrUpdateMomDetail('N');

  const templateObj = {
      "minTemplateId": event.value
  };
  
  this.meetingService.fetchMinutesTemplateById(templateObj).subscribe((response: any) => {
  this.spinner.hide();
  const dialogRef = this.dialog.open(TemplateDialogComponent, {
    data: { htmlContent: response.body.formatedHTML },
    panelClass: ['animate__animated', 'animate__slideInLeft'],
    disableClose: true,
    position: {
      left: "0%"
    },
    maxWidth: "100vw",
    maxHeight: "100vh",
    width: "50%",
    height: "100vh"
    })
    const mediumDialogSubscription = this.isMedium.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('70vw', '100vh');
      }
    })
    const smallSubscription = this.isSmall.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('100vw', '100vh');
      }
    })
    const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
      if (size.matches) {
        dialogRef.updateSize('100vw', '100vh');
      }
      // else {
      //   this.matDialogRef.updateSize('50%', '100vh');
      // }
    });
  })

}


}
